import React from 'react'

export default function NotFoundPage(): React.ReactElement {
   return <p>Not Found :(</p>
}
